import { NgModule } from '@angular/core'
import { AtylDialogDraggableDirective } from './draggable/draggable.directive'
import { VarDirective } from './var/ng-var.directive'

const DIRECTIVES = [
	AtylDialogDraggableDirective,
	VarDirective
]

@NgModule({
	declarations: [
		...DIRECTIVES
	],
	exports: [
		...DIRECTIVES
	],
	imports: [],
	providers: [
	],
	entryComponents: []
})
export class DirectivesModule {
}
